import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import Home from "./pages/Home";
import RealEstatePage from "./pages/RealEstate";
import B2BPage from "./pages/B2B";
import AboutPage from "./pages/About";

import TermsPage from "./pages/Terms";
import PrivacyPage from "./pages/Privacy";
import ImpresszumPage from "./pages/Impresszum";
import RegistrationPage from "./pages/Registration";
import CookiePolicyPage from "./pages/CookiePolicy";
import MaterialsPage from "./pages/Materials";
import NotFoundPage from "./pages/NotFound";
import { CookieConsent } from "./components/CookieConsent";
import { ScrollToTopButton } from "./components/ScrollToTopButton";
import { initGTMConsent, trackPageView } from "./utils/analytics";

// Initialize GTM consent state on app load
initGTMConsent();

// Scroll to top on forward navigation, restore position on back/forward
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else if (navigationType !== 'POP') {
      // Only scroll to top on PUSH/REPLACE (forward navigation)
      // POP = back/forward button — let browser restore scroll position
      window.scrollTo(0, 0);
    }

    // Track virtual page view on every route change
    trackPageView(pathname + (hash || ''));
  }, [pathname, hash, navigationType]);

  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#404041]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ingatlan" element={<RealEstatePage />} />
          <Route path="/b2b" element={<B2BPage />} />
          <Route path="/rolunk" element={<AboutPage />} />
          <Route path="/idopontfoglalas" element={<RegistrationPage />} />
          <Route path="/jelentkezes" element={<RegistrationPage />} />
          <Route path="/aszf" element={<TermsPage />} />
          <Route path="/adatvedelem" element={<PrivacyPage />} />
          <Route path="/impresszum" element={<ImpresszumPage />} />
          <Route path="/cookie-tajekoztato" element={<CookiePolicyPage />} />
          <Route path="/tananyagok" element={<MaterialsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#18181b',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#f4f4f5',
            },
          }}
        />
        <CookieConsent />
        <ScrollToTopButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
